$(() => {
  $(".recruit__item__ttl__opener").on("click", function() {
    $(this).next().stop().slideToggle()
    $(this).toggleClass('trigger_on')
  })
})
